import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = [ "input" ]
  static values = {
    updateUrl: String
  }

  apply(event) {
    event.preventDefault();
    const promoCode = this.inputTarget.value;
    const checkoutForm = document.getElementById("checkout-form");

    if (checkoutForm) {
      let promoCodeInput = checkoutForm.querySelector('input[name="promo_code"]');

      if (!promoCodeInput) {
        promoCodeInput = document.createElement('input');
        promoCodeInput.type = 'hidden';
        promoCodeInput.name = 'promo_code';
        checkoutForm.appendChild(promoCodeInput);
      }

      promoCodeInput.value = promoCode;

      // Now, submit the form to update the order summary
      const formData = new FormData(checkoutForm);

      post(this.updateUrlValue, {
        body: formData,
        responseKind: "turbo-stream"
      }).then(() => {
        // Clear the input field after successful application
        this.inputTarget.value = "";
      });
    } else {
      console.error("Could not find the checkout form with id='checkout-form'");
    }
  }
}